import React, { useEffect } from "react";
import {
  experimentalStyled,
  useMediaQuery,
  Container,
  Box,
  IconButton
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import Footer from "./footer/Footer";
import { UserQuery } from '../../apollo/queries'
import { useLazyQuery } from '@apollo/client'
import {initialState, lookupStorageKey} from '../../apollo/cache'
import {useSessionStorageState} from '../../utils/useSessionStorageState'

const MainWrapper = experimentalStyled("div")(() => ({
  display: "block",
  minHeight: "100vh",
  // overflow: "hidden",
  width: "100%",
}));

const PageWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "block",
  flex: "1 1 auto",
  overflow: "hidden",


  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up("lg")]: {
    // paddingTop: "64px",
    paddingTop: "0px",
  },
  [theme.breakpoints.down("lg")]: {

    // paddingTop: "64px",
    paddingTop: "0px",
  },
}));

const FullLayout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = React.useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = React.useState(false);
  const [hasMounted, setHasMounted] = React.useState(false);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(false);
  const [state, setStorageState] = useSessionStorageState(
    lookupStorageKey,
    initialState,
  )

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    // Keep in sync with sidebar's desktop collapse state.
    setIsSidebarCollapsed(lgUp);
  }, [lgUp]);

  useEffect(() => {
    userlogin({
      variables: {email: state?.user?.email, password: state?.user?.password},
    })
  }, [])

  const [userlogin, {loading}] = useLazyQuery(UserQuery, {
    fetchPolicy: 'network-only',
    onCompleted(data) {
      if(data.getUser.id != null) {
        setStorageState({
          ...state,
          authenticated: true,
          user: data.getUser,
          timestamp: Date.now(),
        })
      } else {
        // toastr.error('Email or Password is incorrect! Try again')
        console.log(`Auth Login Error with ${state?.user?.email}`)
      }
    },
    onError(error) {
      console.log(error)
      // setError(
      //   `No User were found matching your email and password. If you believe this is a mistake, please refresh your browser and try again.`,        
      // )
    },
  })

  const isAuthenticated = hasMounted && state?.authenticated

  return (
    <MainWrapper>
      {/* <Header
        sx={{
          paddingLeft: isSidebarOpen && lgUp ? "265px" : "",
          backgroundColor: "#fbfbfb",
        }}
        toggleMobileSidebar={() => setMobileSidebarOpen(true)}
      /> */}
      {isAuthenticated && (
        <>
          <IconButton
            size="large"
            color="inherit"
            aria-label="menu"
            onClick={() => setMobileSidebarOpen(true)}
            sx={{
              display: {
                lg: "none",
                xs: "flex",
              },
            }}
            className="mobile-menu"
          >
            <FeatherIcon icon="menu" width="20" height="20" />
          </IconButton>
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            isMobileSidebarOpen={isMobileSidebarOpen}
            onSidebarClose={() => setMobileSidebarOpen(false)}
            onCollapsedChange={(collapsed) => setIsSidebarCollapsed(collapsed)}
          />
        </>
      )}
      {/* <PageWrapper>
        <Container
          maxWidth={false}
          sx={{
            paddingLeft: isSidebarOpen && lgUp ? "265px!important" : "",
          }}
        >
          <Box sx={{ minHeight: "calc(100vh - 170px)" }}>{children}</Box>
        </Container>
      </PageWrapper> */}
      <PageWrapper sx={{
            marginLeft: isAuthenticated && isSidebarOpen && lgUp ? `${isSidebarCollapsed ? "73px" : "265px"}!important` : "",
            transition: isAuthenticated ? `margin-left 360ms cubic-bezier(0.2, 0.8, 0.2, 1)` : "none",
            backgroundColor: "white",
          }}>
        <Box sx={{ minHeight: isAuthenticated ? "calc(100vh - 170px)" : "100vh" }}>{children}</Box>
      </PageWrapper>
    </MainWrapper>
  );
};

export default FullLayout;
